import LeadForm from "../components/sections/LeadForm";
import SectionHeader from "../components/ui/SectionHeader";
import { contacts, formatPhone } from "../data/siteData";

function ContactPage() {
  return (
    <section className="page-section">
      <div className="shell">
        <SectionHeader kicker="Kontakt" title="Nová zakázka">
          Pošlete popis práce a kontakt. Ozvu se s dalším postupem nebo termínem prohlídky.
        </SectionHeader>

        <div className="mt-10 grid gap-8 lg:grid-cols-[1fr_360px]">
          <LeadForm />
          <aside className="card p-6">
            <h2 className="text-xl font-bold text-white">Kontakt</h2>
            <div className="mt-5 space-y-4 text-sm leading-6 text-slate-300">
              <p>
                <span className="block font-semibold text-white">Telefon</span>
                  <a href={`tel:+420`+contacts.tel}>+420 {formatPhone(contacts.tel)}</a>
              </p>
              <p>
                <span className="block font-semibold text-white">E-mail</span>
                  <a href={`mailto:`+contacts.email}>{contacts.email}</a>
              </p>
              <p>
                <span className="block font-semibold text-white">Oblast</span>
                Karlovarský kraj a okolí
              </p>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}

export default ContactPage;
